export const APP_VERSION = {
    version: '1.0.1',
    buildTime: new Date().toISOString(),
    environment: process.env.REACT_APP_ENVIRONMENT || 'unknown',
    backendUrl: process.env.REACT_APP_JAVA_BACKEND_URL || 'not-set',
    wsUrl: process.env.REACT_APP_WS_URL || 'not-set',
    buildNumber: process.env.REACT_APP_BUILD_NUMBER || Date.now()
};

// Version info logging removed for security - sensitive configuration should not be logged font-weight: bold');

// Export for use in other components
export default APP_VERSION;